import React from "react";
import {
  Button,
  CloseButton,
  Container,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { connect } from "react-redux";

import withRouter from "../../Components/wrappers/with-router";
import UnpActions from "../../Stores/redux/UnPersist/Actions";
import PActions from "../../Stores/redux/Persist/Actions";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../Components/Models/confirmation-modal";
import { PureAppComponent } from "../../Components/AppComponent";
import { logout } from "../../Modules/auth/logout";
import { exitImpersonating } from "../../Modules/auth/startup";
import { getFullName } from "../../Modules/utils/fullname";

const SCREEN_NAME = "NAVBAR";

class NavBar extends PureAppComponent {
  render() {
    const {
      props: { activeLink, user },
    } = this;

    return user.role === "headOffice" ? (
      <Navbar bg="primary" variant="dark" expand="md" className="topnavbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            Dhing Online Service - Head Office
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="topnavbar-nav" />
          <Navbar.Collapse id="topnavbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" active={activeLink === "/"}>
                Dashboard
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/transaction"
                active={activeLink === "/transaction"}
              >
                Transactions
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/offices"
                active={activeLink === "/offices"}
              >
                Offices
              </Nav.Link>
              <NavDropdown
                title=""
                id="topnav-user-dropdown"
                align="end"
                active={activeLink === "/trlog"}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/trlog"
                  active={activeLink === "/trlog"}
                >
                  Transaction Logs
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav>
              <NavDropdown
                title={user.username}
                id="topnav-user-dropdown"
                align="end"
                active={activeLink === "/user"}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/profile"
                  active={activeLink === "/profile"}
                >
                  Change Password
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/setting"
                  active={activeLink === "/setting"}
                >
                  Setting
                </NavDropdown.Item>

                <LogoutButton />
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    ) : (
      <Navbar bg="dark" variant="dark" expand="md" className="topnavbar">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <div style={{ fontSize: "1rem" }}>
              {getFullName(this.props.user)}
            </div>
            <div style={{ fontSize: "0.6rem" }}>Dhing Online Service</div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="topnavbar-nav" />
          <Navbar.Collapse id="topnavbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={Link}
                to="/transaction"
                active={activeLink === "/transaction"}
              >
                Transactions
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/summary"
                active={activeLink === "/summary"}
              >
                Summary
              </Nav.Link>

              <Nav.Link as={Link} to="/fe" active={activeLink === "/fe"}>
                Field Executives
              </Nav.Link>
            </Nav>
            <Nav className="align-items-center">
              <NavDropdown
                title={user.username}
                id="topnav-user-dropdown"
                align="end"
                active={activeLink === "/user"}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/profile"
                  active={activeLink === "/profile"}
                >
                  Change Password
                </NavDropdown.Item>

                <NavDropdown.Divider />
                <LogoutButton />
              </NavDropdown>

              {this.props.impersonator ? (
                <Nav.Link as={Link} to="/">
                  <Button
                    className="d-flex gap-1"
                    variant="outline-primary"
                    onClick={exitImpersonating}
                  >
                    <span className="btn-close btn-close-white"></span>
                    Exit Login
                  </Button>
                </Nav.Link>
              ) : null}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

class LogoutButton extends PureAppComponent {
  logout() {
    this.setAsyncState({ showModal: false });
    logout();
  }

  render() {
    return (
      <>
        <NavDropdown.Item
          onClick={() => this.setAsyncState({ showModal: true })}
        >
          Logout
        </NavDropdown.Item>
        <ConfirmationModal
          visible={!!this.state.showModal}
          handleClose={() => this.setAsyncState({ showModal: false })}
          onSubmit={this.logout.bind(this)}
          body="Are you sure you want to logout ?"
          submitBtnText="Logout"
          title="Confirm Logout"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  screenState: state.vState[SCREEN_NAME] || {},
  user: state.pState.user.user,
  impersonator: state.pState.user.impersonator,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar));
